import { from, of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { combineEpics, ofType } from "redux-observable";
import {
  types,
  fetchDevicesSuccess,
  fetchDevicesError,
  revokeDeviceSuccess,
  revokeDeviceError,
  fetchDevices,
} from "./devices.redux";
import { api } from "../api/api";

const fetchDevicesEpic = (action$) =>
  action$.pipe(
    ofType(types.fetchDevices),
    mergeMap(() => {
      const { ajaxSession } = api;
      return from(ajaxSession("userDevice/mine", { type: "GET" })).pipe(
        map((response) =>
          fetchDevicesSuccess({ devices: response.appuserdevice || [] }),
        ),
        catchError((error) => {
          console.error("fetchDevices error", error);
          return of(fetchDevicesError({ error: String(error) }));
        }),
      );
    }),
  );

const revokeDeviceEpic = (action$) =>
  action$.pipe(
    ofType(types.revokeDevice),
    mergeMap(({ payload }) => {
      const { ajaxSession } = api;
      const { deviceId } = payload;
      return from(
        ajaxSession(`userDevice/${deviceId}/revoke`, {
          type: "POST",
          data: {},
        }),
      ).pipe(
        mergeMap(() => of(revokeDeviceSuccess({ deviceId }), fetchDevices())),
        catchError((error) => {
          console.error("revokeDevice error", error);
          return of(revokeDeviceError({ error: String(error) }));
        }),
      );
    }),
  );

export default combineEpics(fetchDevicesEpic, revokeDeviceEpic);
